module.exports = __webpack_public_path__ + "img/20191231154351360截图20191231113501231.6d445cc3.jpg";